import Api, {
  baseURL,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsPOSTWithArrayBody,
  requestOptionsDELETE,
  requestOptionsDELETEWithBody
} from '../api';
import newFetch from '../utils/newFetch';

const state = {
  deliveries: [],
  unallocatedNfes: [],
  ctes: []
};

const getters = {
  getDeliveries: (state) => state.deliveries,
  getUnallocatedNfes: (state) => state.unallocatedNfes,
  getCtes: (state) => state.ctes
};

const mutations = {
  setDeliveriesByid(state, payload) {
    state.deliveries = payload;
  },
  setUnallocatedNfesByid(state, payload) {
    state.unallocatedNfes = payload;
  },
  setCtes(state, payload) {
    state.ctes = payload;
  },
  updateCtes(state, updatedItem) {
    const index = state.items.findIndex((item) => item.id === updatedItem.id);
    if (index !== -1) {
      state.items.splice(index, 1, updatedItem);
    }
  }
};

const actions = {
  getAllDeliveries(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getDeliveriesManualBoarding + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          context.commit('setDeliveriesByid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getAllCtes(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getCtesManualBoarding + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getAllUnallocatedNfes(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getUnallocatedNfesManualBoarding + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          context.commit('setUnallocatedNfesByid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createNewDelivery(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createDeliveryManualBoarding + id, requestOptionsPOST(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createGroupedDeliveries(_, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.createGroupedDeliveries + model.processId,
        requestOptionsPOST(localStorage.getItem('accessToken'), { nfesIds: model.nfesIds })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createDeliveriesDetailsData(_, deliveriesDetailsData) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.updateDeliveriesDetailsData,
        requestOptionsPOSTWithArrayBody(localStorage.getItem('accessToken'), deliveriesDetailsData)
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  allocateNfes(_, params) {
    const body = {
      nfesIds: params.nfeIds
    };
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.allocateNfesManualBoarding + params.id,
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getNfesByDeliveryId(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNfesByDeliveryIdManualBoarding + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deallocateNfes(_, params) {
    const body = {
      nfesIds: params.nfeIds
    };
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deallocateNfesManualBoarding + params.id,
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteDelivery(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteDeliveryManualBoarding + id,
        requestOptionsDELETE(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  },
  deleteMultipleDeliveries(_, ids) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteMultipleDeliveryManualBoarding,
        requestOptionsDELETEWithBody(localStorage.getItem('accessToken'), { deliveriesIds: ids })
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
